module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/revert-back-e0df210c266be04e67a3b38a721303b7.svg";